import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/layout/default.vue'
import blankLayout from '@/layout/blank.vue'
import eventMobileLayout from '@/layout/eventMobile.vue'
import { beforeEach } from './guards'
import home from '../views/home/home.vue'
import scheme from '../views/scheme/index.vue'
import schemeView from '../views/scheme/view.vue'
import service from '../views/service/index.vue'
import serviceProvider from '../views/service-provider/index.vue'
import cooperation from '../views/cooperation/index.vue'
import policy from '../views/servePolicy/policy.vue'
import serve from '../views/servePolicy/serve.vue'
import schemeChat from '../views/scheme-chat/index.vue'
import supplierSignatureBasicInfo from '../views/supplier-signature/basic-info.vue'
import supplierSignatureSubmitted from '../views/supplier-signature/submitted.vue'
import supplierSignatureSucceed from '../views/supplier-signature/succeed.vue'
import schemeSignatureBasicInfo from '../views/scheme-signature/basic-info.vue'
import schemeSignatureSubmitted from '../views/scheme-signature/submitted.vue'
import schemeSignatureSucceed from '../views/scheme-signature/succeed.vue'
import supplier from './modules/supplier/index';
import project from './modules/project/index';
import { children as supplyEcosystem } from './modules/supplyEcosystem/index';
import { children as schemeEcosystem } from './modules/schemeEcosystem/index';

const EmptyRouterView = { render: (h) => h('router-view') };

Vue.use(VueRouter)

const routes = [{
  path: '/',
  redirect: '/home',
  component: layout,
  children: [{
    path: 'home',
    name: 'home',
    component: home
  }, {
    path: 'scheme',
    name: 'scheme',
    component: scheme
  }, {
    path: 'scheme/view',
    name: 'schemeView',
    component: schemeView
  }, {
    path: 'scheme/chat',
    name: 'schemeChat',
    component: schemeChat,
    meta: {
      needLogin: true
    }
  }, {
    path: 'service',
    name: 'service',
    component: service
  }, {
    path: 'service-provider',
    name: 'serviceProvider',
    component: serviceProvider
  }, {
    path: 'cooperation',
    name: 'cooperation',
    component: cooperation
  }, {
    path: 'servePolicy/policy',
    name: 'policy',
    component: policy
  }, {
    path: 'servePolicy/serve',
    name: 'serve',
    component: serve
  }, {
    path: 'servePolicy/serve',
    name: 'serve',
    component: serve
  }, {
    path: 'supplier-signature/basic-info',
    name: 'supplierSignatureBasicInfo',
    component: supplierSignatureBasicInfo,
  }, {
    path: 'supplier-signature/submitted',
    name: 'supplierSignatureSubmitted',
    component: supplierSignatureSubmitted,
  }, {
    path: 'supplier-signature/succeed',
    name: 'supplierSignatureSucceed',
    component: supplierSignatureSucceed,
  }, {
    path: 'supplier-signature/change',
    name: 'supplierSignatureChange',
    component: () => import('../views/supplier-signature/change.vue'),
  }, {
    path: 'scheme-signature/basic-info',
    component: schemeSignatureBasicInfo,
  }, {
    path: 'scheme-signature/submitted',
    component: schemeSignatureSubmitted,
  }, {
    path: 'scheme-signature/succeed',
    component: schemeSignatureSucceed,
  }, {
    path: 'scheme-signature/change',
    component: () => import('../views/scheme-signature/change.vue'),
  }, {
    path: 'ecosystem',
    component: () => import('../views/ecosystem/index.vue'),
  }, {
    path: 'personalInfo',
    name: 'personalInfo',
    component: () => import('../views/personalInfo/change.vue'),
  }]
}, {
  path: '/supplyEcosystem',
  component: blankLayout,
  children: supplyEcosystem
}, {
  path: '/schemeEcosystem',
  component: blankLayout,
  children: schemeEcosystem
}, {
  path: '/scheme-preview',
  name: 'schemePublicPreview',
  component: () => import('../views/schemeEcosystem/pages/ExhibitionPublicPreview.vue'),
  meta: { title: '方案预览', hideGlobalDialogue: true, publicPreview: true }
}, {
  path: '/event',
  component: eventMobileLayout,
  redirect: '/event/sign-in',
  children: [{
    path: 'sign-in',
    name: 'eventSignIn',
    component: () => import('../views/event/signIn.vue'),
    meta: { title: '活动签到', hideGlobalDialogue: true }
  }, {
    path: 'lottery',
    name: 'eventLottery',
    component: () => import('../views/event/lottery.vue'),
    meta: { title: '幸运抽奖', hideGlobalDialogue: true }
  }, {
    path: 'survey',
    name: 'eventPartnerSurvey',
    component: () => import('../views/event/survey.vue'),
    meta: { title: '合伙人调研问卷', hideGlobalDialogue: true }
  }]
}, {
  path: '/supplier',
  meta: { title: '供应商' },
  component: EmptyRouterView,
  children: supplier
}, {
  path: '/project',
  meta: { title: '项目' },
  component: EmptyRouterView,
  children: project
}]

const router = new VueRouter({
  base: process.env.BASE_URL || '/',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
})

router.beforeEach(beforeEach)

export default router
